<script>
	// Stores
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	// Components
	import SelectInput from '@/Components/SelectInput.svelte';

	export let selectedClassificationId;
	export let name;
	export let className = 'pr-6 w-full';
</script>

<SelectInput {className} {name} bind:value={selectedClassificationId}>
	<option>Unclassified</option>
	{#each $ClassificationStore
		.sortBy((classification) => parseInt(classification.id))
		.all() as classification (classification.id)}
		<option value={classification.id.toString()}>{classification.name}</option>
	{/each}
</SelectInput>
